<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :btnFlag="false" :buttonFlag="false">
        <template slot="button">
          <div>
            <el-button type="primary" size="mini" @click="addOrgin(1)">修改</el-button>
            <el-button type="primary" size="mini" @click="addOrgin(5)">设置范围</el-button>
            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
              刷新
            </el-button>
          </div>
        </template>
      </v-button>
    </div>
    <div class="page_content_center">
      <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column align="center" prop="ormId" label="组织ID" width="140"></el-table-column>
        <el-table-column align="center" prop="ormName" label="组织名称" min-width="160"></el-table-column>
        <el-table-column align="center" prop="manrangeName" label="经营范围" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="prorangeName" label="生产范围" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="ormState" label="组织状态">
          <template slot-scope="scope">
            <el-tag size="mini">{{ organizationStatus[scope.row.ormState].name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="deliveryAddress" label="发货地址" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="entrustAgent" label="委托经办人" min-width="90" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="contactPerson" label="联系人" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="contactPhone" label="联系电话" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="authDate" label="授权时间"  min-width="90" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{$common.getLocalTime(scope.row.authDate)}}
            <!-- <span>{{ $common.getLocalTime(scope.row.authDate) }}</span> -->
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isSl" label="是否启用货位" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.isSl == 1 ? '启用' : '不启用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isAdjuest" label="退补是否调整成本" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.isAdjuest == 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isContractaudit" label="合同是否审核" :show-overflow-tooltip="true" min-width="100"> 
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.isContractaudit == 'true' ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isPick" label="是否拣货" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.isPick == 1 ? '启用' : '不启用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="priceVerify" label="验收是否核价" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.priceVerify == 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isMustHospital" label="医院是否必填" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.isMustHospital == 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="wesName" label="电子监管码单位名称" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    <!-- 修改 -->
    <organizationActions ref="organizationAction" @closeAction="closeAction"></organizationActions>
    <!-- 设置范围 -->
    <organizationalRange ref="organizationalRange" @close="close"></organizationalRange>
    <!-- <backUpsList ref="backUpsList"></backUpsList> -->
  </div>
</template>

<script>
import organizationalRange from "@/components/organizationalRange.vue";
import organizationActions from "@/components/organizationActions.vue";
export default {
  components: {
    organizationalRange,
    organizationActions
  },
  data() {
    return {
      tableHeight: 100,
      getRequestData: {
        ormName: "",//组织名称
        ormState: "",//状态
        page: 1,
        rows: 10,
      },
      returnData: {
        list: [],
        total: 0,
      },
      organizationStatus: [
        { id: 0, name: "停用" },
        { id: 1, name: "启用" },
      ],
    }
  },
  created() {
  },
  methods: {
    //按钮控制
    addOrgin(type) {
      switch (type) {
        case 1://修改
          if (this.returnData.list <= 0) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.returnData.list[0];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.$refs["organizationAction"].openBox(type, dataInfo);
          break;
        case 5://设置范围
          var dataInfo = this.returnData.list[0];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.$refs["organizationalRange"].openBox(dataInfo);
          break;

      }
    },
    //设置范围之后关闭弹框刷新列表
    close() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    //修改之后关闭弹框刷新列表
    closeAction() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    //刷新
    getPageInfo() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    //检索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList();
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },
    //列表渲染
    async getDataList() {
      const responseData = await this.$http.OrganizationqueryCurrentOrm(this.getRequestData)
      console.log(responseData);
      if (responseData.status == 200) {
        this.returnData.list = [responseData.result]
        this.tableHeight = this.$common.getTableHeight()
      }
    }
  },
  mounted() {
    this.getDataList()
  },
  updated() { this.tableHeight = this.$common.getTableHeight() },
}
</script>

<style></style>